<template>
	<div class="menu">
        <!-- :class="{disabled: item.activeLocation > currentLocation}" -->
        <router-link
			v-for="(item,index) in menuItems"
			:key="index" :to="item.activeLink"
			class="menu__item"
			:class="{disabled: item.activeLocation > $store.state.currentLocation, menuCompleted: item.activeLocation < $store.state.currentLocation }"
			@click="$emit('menu-clicked')"
		>
            <div class="menu__status"><img :src="require(`@/assets/img/_menu/${item.currentIcon}`)" alt=""></div>
            <div class="menu__thumb"><img :src="require(`@/assets/img/_menu/${item.imgSrc}`)" class="img-fluid" alt="" srcset=""></div>
            <div class="menu__title">{{item.title}}</div>
        </router-link>
    </div>
</template>

<script>


export default {
  props: ['menuItems'],
  data() {
    return {

    };
  },
  methods: {
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>

	/*------------------------------------*\
		#PRIMARY COLOURS
	\*------------------------------------*/
	$red: #DA2128;

  /*------------------------------------*\
		#Mixins
	\*------------------------------------*/
	@mixin blur($prop) {
		-webkit-filter: blur($prop);
		-moz-filter: blur($prop);
		-o-filter: blur($prop);
		-ms-filter: blur($prop);
		filter: blur($prop);
	}
  /*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
	\*------------------------------------*/
	/**
	* MENU
	*/
	.menu {
		// background-color: $red;
		color: #fff;

		.disabled {
			pointer-events: none;
			// opacity: 0.6;
			background: none;
			color: #000;
			// box-shadow: none;
			filter: grayscale(50%);
			-webkit-filter: grayscale(50%); /* Safari 6.0 - 9.0 */

			.menu__title {
				color: #000;
			}

			.menu__thumb {
				filter: grayscale(100%);
				-webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
			}
		}

		&__item {
			display: flex;
			text-align: center;
			// margin: 1em 0;
			padding: 1em 0;
			border-bottom: 1px solid #000;
			// background: linear-gradient(to bottom left, #C02B30, #DA2128);
			// cursor: pointer;

			background-color: $red;
			color: #fff;
			// box-shadow: 0px 0px 5px rgba($color: #90101F, $alpha: 1.0);
			border: 2px solid #fff;

			.menu__title {
				color: #fff;
			}
		}

		&__status {
			display: inline-block;
			width: 10%;
			margin: auto;
		}

		&__thumb {
			display: inline-block;
			width: 35%;
			margin: auto;

			// opacity: 0.6;
			filter: grayscale(50%);
			-webkit-filter: grayscale(50%); /* Safari 6.0 - 9.0 */
			transition: all 0.4s;

			&:hover {
					opacity: 1;
					filter: grayscale(0%);
					-webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
			}
		}

		&__title {
			display: inline-block;
			width: 45%;
			margin: auto;
			text-align: left;
			font-size: 1em;
			padding: 1em 35px 1em 15px;
			color: #000;
			// text-transform: capitalize;

			&:hover {
					text-decoration: underline;
			}
		}
	}
	/*------------------------------------*\
		#MEDIA SCREENS > 576px (TABLETS)
	\*------------------------------------*/
	@media (min-width:576px) {
		/**
		* MENU
		*/
		// .menu {
		// 	&__item {
		// 		background: linear-gradient(to bottom left, #C02B30, #DA2128);
		// 	}
		// }
	}

  /*------------------------------------*\
		#MEDIA SCREENS > 767px (TABLETS)
	\*------------------------------------*/
	@media (min-width:767px) {
		/**
    * MENU
    */
    .menu {
			padding: 2em;
			display: flex;
			flex-wrap: wrap;

			&__item {
					display: block;
					position: relative;
					text-align: center;
					width: 23%;
					padding: 1em;

					margin: 1%;
					min-height: 20em;
					// box-shadow: 0px 0px 15px rgba($color: #000000, $alpha: 1.0);
					// border-bottom: none;
					border: 2px solid #000;

					// background: linear-gradient(to bottom left, #C02B30, #DA2128);
			}

			&__status {
					display: inline-block;
					position: absolute;
					bottom: 10px;
					width: 100%;
					margin: auto -1em;
			}

			&__thumb {
					display: inline-block;
					width: 100%;
					margin: auto;
			}

			&__title {
					display: inline-block;
					width: 100%;
					margin: auto;
					text-align: left;
					font-size: 1em;
					padding: 1em 0;
					text-align: center;
			}
    }

    .menuCompleted {
    //   background-color: $red;
    //   color: #fff;
    //   box-shadow: 0px 0px 20px rgba($color: #90101F, $alpha: 1.0);
    //   border: 2px solid #fff;

    //   .menu__title {
    //     color: #fff;
    //   }
		// background: none;
		// .menu__title {
		// 	color: #000;
		// }
    }
	}

	/*------------------------------------*\
		#MEDIA SCREENS > 992px
		(LAPTOP, TABLET)
	\*------------------------------------*/
	@media (min-width:992px) {

	}

	/*------------------------------------*\
		#MEDIA SCREENS > 1200px (DESKTOP)
	\*------------------------------------*/
	@media (min-width:1200px) {

	}

	/*------------------------------------*\
		#MEDIA SCREENS > 1320px (DESKTOP)
	\*------------------------------------*/
	@media (min-width:1320px) {

	}

	/*------------------------------------*\
		#MEDIA SCREENS > 1600px (DESKTOP)
	\*------------------------------------*/
	@media (min-width:1600px) {

    }
</style>
